import Handlebars from 'injectify/runtime';
import {APP_FEATURES} from '../../js/resources/SessionObjects';
import {router} from '../../js/router';

export function isFeatureActive (feature) {
    let country = router.getLastEventCountryCode();

    if(_.isUndefined(country)) {

        country = window.location.pathname.split('/')[2] ? _.head(window.location.pathname.split('/')[2].split('_')) : undefined;
    }

    return APP_FEATURES.isFeatureEnabled({feature, country});
}

/**
 * Checks if feature enabled under
 */
Handlebars.registerHelper('if-feature', function (feature, options) {
    return isFeatureActive(feature, options) ? options.fn(this) : options.inverse(this);
});



// WEBPACK FOOTER //
// ./shared/helper/ifFeature.js